export const SET_ALL_APPS = 'SET_ALL_APPS'
